import * as types from './project-times.types';
export const projectTimesPageSelectors: types.IProjectTimesPageSelectors = {
  selectProjectTimes: (state) => state.page.projectTimes.projectTimesIds,
};
